import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { error } from 'jquery';



@Component({
  selector: 'app-login-daftar',
  templateUrl: './login-daftar.component.html',
  styleUrls: ['./login-daftar.component.css']
})


export class LoginDaftarComponent implements OnInit{
  isLoading: boolean = false;
  errorMessage: string = '';
  registerForm!: FormGroup;
  submitted = false;

  recaptchaSiteKey: string = environment.recaptchaSiteKey;
  recaptchaVerified: boolean = false;
  isPasswordVisible = false;
  isPasswordVisible2 = false;

  constructor(
  private fb: FormBuilder, 
  private router: Router,
  private route: ActivatedRoute,
  private authService: AuthService,
  ) {
    this.initializeForms();
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  
  togglePasswordVisibility2(): void {
    this.isPasswordVisible2 = !this.isPasswordVisible2;
  }

  private initializeForms() {        // Add registration form
      this.registerForm = this.fb.group({
        name_reg: ['', [Validators.required]],
        email_reg: ['', [Validators.required, Validators.email]],
        password_reg: [
          '',
          [
            Validators.required,
            Validators.minLength(6), // Minimum 6 karakter
            this.passwordValidator, // Validator kustom
          ]
        ],
        confirmPassword: ['', [Validators.required]], // Tambahkan field konfirmasi password
        recaptcha: ['', Validators.required],
      }, { validators: this.passwordsMatchValidator });
  }

  // Validator kustom untuk password
  private passwordValidator(control: any): { [key: string]: boolean } | null {
    const password = control.value;

    if (!password) {
      return null; // Valid jika tidak ada input (akan ditangani oleh Validators.required)
    }

    // Regex untuk huruf besar dan angka
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);

    if (!hasUppercase || !hasNumber) {
      return { invalidPassword: true }; // Return error jika tidak valid
    }

    return null; // Return null jika valid
  }





    // Validator kustom untuk mencocokkan password dan confirmPassword
private passwordsMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
  const password = group.get('password_reg')?.value;
  const confirmPassword = group.get('confirmPassword')?.value;

  // Return a ValidationErrors object if the passwords do not match
  return password === confirmPassword ? null : { passwordsMismatch: true };
}

  
  ngOnInit(): void {
    // Get query params from URL
    this.route.queryParams.subscribe(params => {
      const emailUser = params['email']; // Replace 'user_email' with your query parameter name
      if (emailUser) {
        this.registerForm.patchValue({
          email_reg: emailUser
        });
      }
    });
  }

  daftar(): void{
    this.submitted = true;

   // Verify reCAPTCHA
   const recaptchaResponse = (window as any).grecaptcha.getResponse();
   this.recaptchaVerified = recaptchaResponse.length > 0;

   if (this.registerForm.valid && this.recaptchaVerified) {
     this.isLoading = true;

     const formData = this.registerForm.value;
     const payload = {
         name: formData.name_reg,
         email: formData.email_reg,
         password: formData.password_reg,
     };


     this.authService.registerWithEmail(payload).subscribe(
      (res: any) => {
        this.isLoading = false;

        const dt = res.user;
            
        // Simpan data ke localStorage
        localStorage.setItem('authToken', res.token);
        localStorage.setItem('user_name', dt.nama);
        localStorage.setItem('user_email', dt.email);
        localStorage.setItem('user_photo', dt.foto || '');
        localStorage.setItem('user_wa', dt.whatsapp_number);
        localStorage.setItem('user_login', 'email');
        
        // Menyimpan objek data pengguna untuk penggunaan lainnya
        localStorage.setItem('user_pelanggan', JSON.stringify({
          name: dt.nama,
          email: dt.email,
          photo: dt.foto
        }));
          // Dapatkan rute asal
          const redirectUrl = this.authService.getRedirectUrl() || '/home'; // Default ke /dashboard jika tidak ada rute asal
          window.location.href = redirectUrl;
          this.submitted = false;
        });
   }

  }

 // Safely get form control with null check
 getFormControl(form: FormGroup, controlName: string): AbstractControl | null {
  return form.get(controlName);
}

// Safely check if control has specific error
hasError(form: FormGroup, controlName: string, errorType: string): boolean {
  const control = this.getFormControl(form, controlName);
  return control ? (this.submitted && control.hasError(errorType)) : false;
}

}
